// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2isbC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2DBFs","obliqueLine":"membershipbadge_obliqueLine__XnaVp"};